// Shared, theme-aware react-select styles that match the `.al-input` design.
// Uses CSS custom properties so it works in both light and dark themes.
export const alSelectStyles = {
  control: (styles, { isFocused, isDisabled }) => ({
    ...styles,
    minHeight: "42px",
    border: `1px solid ${isFocused ? "var(--color-primary)" : "var(--color-border)"}`,
    borderRadius: "10px",
    backgroundColor: isDisabled ? "var(--color-surface-2)" : "var(--color-surface)",
    boxShadow: isFocused ? "0 0 0 3px var(--color-primary-weak)" : "none",
    fontSize: "13.5px",
    fontWeight: 600,
    padding: "1px 3px",
    transition: "border-color .15s ease, box-shadow .15s ease",
    "&:hover": {
      border: `1px solid ${isFocused ? "var(--color-primary)" : "var(--color-border)"}`,
    },
  }),
  valueContainer: (styles) => ({ ...styles, padding: "2px 9px" }),
  placeholder: (styles) => ({
    ...styles,
    color: "var(--color-text-tertiary)",
    fontWeight: 500,
  }),
  singleValue: (styles) => ({ ...styles, color: "var(--color-text-primary)" }),
  input: (styles) => ({ ...styles, color: "var(--color-text-primary)" }),
  menu: (styles) => ({
    ...styles,
    backgroundColor: "var(--color-surface)",
    border: "1px solid var(--color-border)",
    borderRadius: "10px",
    overflow: "hidden",
    zIndex: 30,
    boxShadow: "var(--shadow-card)",
  }),
  menuList: (styles) => ({ ...styles, padding: "5px" }),
  menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isSelected
      ? "var(--color-primary-weak)"
      : isFocused
      ? "var(--color-hover)"
      : "transparent",
    color: isSelected ? "var(--color-primary)" : "var(--color-text-primary)",
    fontSize: "13px",
    fontWeight: isSelected ? 700 : 500,
    borderRadius: "7px",
    cursor: "pointer",
    ":active": { backgroundColor: "var(--color-primary-weak)" },
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "var(--color-primary-weak)",
    borderRadius: "6px",
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "var(--color-primary)",
    fontWeight: 600,
    fontSize: "12px",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "var(--color-primary)",
    borderRadius: "0 6px 6px 0",
    ":hover": { backgroundColor: "var(--color-primary)", color: "#fff" },
  }),
  noOptionsMessage: (styles) => ({
    ...styles,
    color: "var(--color-text-tertiary)",
    fontSize: "13px",
  }),
};

export default alSelectStyles;
